import React from 'react';

import styles from './SiteRequirements.module.postcss';

function SiteRequirements() {
  return (
    <div className='GrayBg'>
      <section className={'Section--extraPadding ' + styles.SiteRequirements}>
        <div>
          <img src='/static/images/truck_illo.png' alt='' loading='lazy' />
        </div>
        <div>
          <h3>What we need on site</h3>

          <div className={styles.SiteRequirements_grid}>
            <div><strong>Power:</strong></div>
            <div>Usually not needed</div>

            <div><strong>Space:</strong></div>
            <div>About 30 ft × 8 ft to park and serve</div>

            <div><strong>Water:</strong></div>
            <div>Not usually needed</div>

            <div><strong>Parking:</strong></div>
            <div>A flat surface with a clear approach</div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default SiteRequirements;
